module.exports = __webpack_public_path__ + "static/media/svg-1.dc919a74.svg";